import { Directive, HostListener, Input, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[onlyNumber]',
  standalone: true
})
export class OnlyNumberDirective {
  @Input() decimals: number = 0;

  private regex!: RegExp;
  private updating = false; // ⚡ flag anti-boucle

  constructor(@Optional() @Self() private control: NgControl) {}

  ngOnInit() {
    this.regex = this.decimals > 0
      ? new RegExp(`^\\d*(\\.\\d{0,${this.decimals}})?$`)
      : new RegExp(`^\\d*$`);

    // format initial sans déclencher valueChanges
    this.formatValue();
  }

  @HostListener('input', ['$event'])
  onInput(event: any) {
    if (this.updating) return;

    const value = event.target.value;

    if (value === '' || this.regex.test(value)) {
      // valeur valide → rien à faire
      return;
    }

    this.updating = true;

    const control = this.control?.control;
    if (control) {
      const lastValid = control.value || '';
      event.target.value = lastValid; // revert à la dernière valeur valide
      control.setValue(lastValid, { emitEvent: false }); // ⚡ silencieux
    }

    this.updating = false;
  }

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    if (!input) return;

    const char = String.fromCharCode(event.charCode);
    const nextValue = input.value + char;

    if (!this.regex.test(nextValue)) {
      event.preventDefault();
    }
  }

  @HostListener('blur')
  onBlur() {
    const control = this.control?.control;
    if (!control) return;

    const value = control.value;
    if (value === null || value === undefined || value === '') return;

    const num = parseFloat(value);
    if (isNaN(num)) return;

    const formatted = this.decimals > 0
      ? num.toFixed(this.decimals)
      : Math.floor(num).toString();

    this.updating = true;
    control.setValue(formatted, { emitEvent: false }); // ⚡ silencieux
    this.updating = false;
  }

  private formatValue() {
    const control = this.control?.control;
    if (!control) return;

    const value = control.value;
    if (value === null || value === undefined || value === '') return;

    const num = parseFloat(value);
    if (isNaN(num)) return;

    const formatted = this.decimals > 0
      ? num.toFixed(this.decimals)
      : Math.floor(num).toString();

    this.updating = true;
    control.setValue(formatted, { emitEvent: false });
    this.updating = false;
  }
}